import React from 'react';
import Image from 'components/AppImage';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const SpecialOffersGrid = ({ onBookNowClick }) => {
  const handleCallForDetails = () => {
    window.open('tel:+918277385225', '_self');
  };

  const specialOffers = [
    {
      id: 1,
      title: "Weekend Getaway",
      originalPrice: "₹3,500",
      discountedPrice: "₹2,499",
      discount: "30% OFF",
      image: "https://images.unsplash.com/photo-1566073771259-6a8506099945",
      duration: "2 Days / 1 Night",
      includes: ["Accommodation", "Breakfast", "River Rafting"],
      validTill: "Valid till Dec 31",
      popular: true
    },
    {
      id: 2,
      title: "Adventure Package",
      originalPrice: "₹5,000",
      discountedPrice: "₹3,999",
      discount: "20% OFF",
      image: "https://images.unsplash.com/photo-1551632811-561732d1e306",
      duration: "3 Days / 2 Nights",
      includes: ["Accommodation", "All Meals", "Safari", "Trekking"],
      validTill: "Limited Period",
      popular: false
    },
    {
      id: 3,
      title: "Family Special",
      originalPrice: "₹8,000",
      discountedPrice: "₹6,499",
      discount: "25% OFF",
      image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d",
      duration: "4 Days / 3 Nights",
      includes: ["Family Room", "All Meals", "Activities", "Bonfire"],
      validTill: "Book by Dec 15",
      popular: false
    }
  ];

  return (
    <section className="py-16 bg-muted">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-4">
            Limited Time Offers
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto font-body">
            Don't miss out on these exclusive deals for your Dandeli adventure
          </p>
        </div>

        {/* Offers Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {specialOffers?.map((offer) => (
            <div
              key={offer?.id}
              className="relative bg-card rounded-2xl shadow-organic overflow-hidden hover-lift group"
            >
              {/* Popular Badge */}
              {offer?.popular && (
                <div className="absolute top-4 left-4 z-10 bg-accent text-accent-foreground px-3 py-1 rounded-full text-sm font-heading font-semibold">
                  Most Popular
                </div>
              )}

              {/* Discount Badge */}
              <div className="absolute top-4 right-4 z-10 bg-error text-error-foreground px-3 py-1 rounded-full text-sm font-heading font-bold">
                {offer?.discount}
              </div>

              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <Image
                  src={offer?.image}
                  alt={offer?.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-organic duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-xl font-heading font-semibold text-text-primary">
                    {offer?.title}
                  </h3>
                  <div className="flex items-center text-accent">
                    <Icon name="Clock" size={16} />
                    <span className="text-sm ml-1 font-body">{offer?.duration}</span>
                  </div>
                </div>

                {/* Pricing */}
                <div className="flex items-baseline space-x-2 mb-4">
                  <span className="text-2xl font-heading font-bold text-primary">
                    {offer?.discountedPrice}
                  </span>
                  <span className="text-lg text-text-secondary line-through font-body">
                    {offer?.originalPrice}
                  </span>
                </div>

                {/* Includes */}
                <div className="mb-4">
                  <h4 className="text-sm font-heading font-semibold text-text-primary mb-2">
                    Package Includes:
                  </h4>
                  <ul className="space-y-1">
                    {offer?.includes?.map((item, index) => (
                      <li key={index} className="flex items-center text-sm text-text-secondary font-body">
                        <Icon name="Check" size={14} className="text-success mr-2 flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Validity */}
                <div className="flex items-center justify-between mb-4">
                  <span className="text-sm text-warning font-heading font-medium">
                    {offer?.validTill}
                  </span>
                </div>

                {/* Action Buttons */}
                <div className="space-y-3">
                  <Button
                    variant="default"
                    size="default"
                    iconName="Calendar"
                    iconPosition="left"
                    fullWidth
                    onClick={() => onBookNowClick?.(offer)}
                    className="hover:scale-105 transition-organic"
                  >
                    Book Now
                  </Button>
                  <Button
                    variant="outline"
                    size="default"
                    iconName="Phone"
                    iconPosition="left"
                    fullWidth
                    onClick={handleCallForDetails}
                    className="border-accent text-accent hover:bg-accent hover:text-accent-foreground"
                  >
                    Call for Details
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-text-secondary mb-4 font-body">
            Need a custom package? We've got you covered!
          </p>
          <Button
            variant="outline"
            size="lg"
            iconName="MessageCircle"
            iconPosition="left"
            onClick={handleCallForDetails}
            className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
          >
            Contact for Custom Package
          </Button>
        </div>
      </div>
    </section>
  );
};

export default SpecialOffersGrid;